import React from "react";
import { Container,  Nav, Tab } from "react-bootstrap";
import DepositPage from "../depositComponents/DepositPage";
import WithdrawPage from "../withdrawComponents/WithdrawPage";
import DepositHistory from "../depositComponents/DepositHistory";
import PayoutHistory from "./PayoutHistory";

const DepositWithdraw = () => (
  <Container className="mt-4" >
    <Tab.Container defaultActiveKey="deposit">
      <Nav variant="tabs" style={{ justifyContent: "center" }}>
        <Nav.Item>
          <Nav.Link eventKey="deposit"> Deposit</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="deposithistory"> Deposit History</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="payouthistory"> Payout History</Nav.Link>
        </Nav.Item>
      </Nav>

      <Tab.Content className="mt-4 card">
        {/* Deposit Section */}
        <Tab.Pane eventKey="deposit">
          <DepositPage />
        </Tab.Pane>
        {/* Deposit History Section */}
        <Tab.Pane eventKey="deposithistory">
          <DepositHistory/>
        </Tab.Pane>
        {/* Payout History Section */}
        <Tab.Pane eventKey="payouthistory">
          <PayoutHistory/>
        </Tab.Pane>


      </Tab.Content>
    </Tab.Container>
  </Container>
);

export default DepositWithdraw;
